import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-06fdeaf4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["onSubmit"];
const _hoisted_3 = {
    key: 0,
    class: "w-72 mx-4",
    src: "/images/logo-impress.svg",
    alt: "Logo"
};
const _hoisted_4 = {
    key: 1,
    class: "w-32",
    src: "/images/logo.svg",
    alt: "Diamond Whites"
};
const _hoisted_5 = {
    key: 2,
    class: "w-32",
    src: "/images/logo-blue.svg",
    alt: "Diamond Whites"
};
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Login", -1));
import { KeyIcon, LoginIcon, UserIcon } from "@heroicons/vue/outline";
import { useDarkMode } from "@/stores/dark-mode";
import Button from "@/components/Button.vue";
import Input from "@/components/Input.vue";
import { useAuthentication } from "@/stores/authentication";
import { reactive, ref, inject } from "vue";
import { isStatusError, isValidationError } from "@/meta";
import { useRouter } from "vue-router";
import { useFetch } from "@/helpers";
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const isImpress = inject('impress');
        const { currentUser, loginUser, fetchCurrentUser } = useAuthentication();
        const { isDarkMode } = useDarkMode();
        const router = useRouter();
        const errors = ref();
        const loading = ref(false);
        const form = reactive({
            email: "",
            password: "",
        });
        const onSubmit = async () => {
            try {
                if (form.email && form.password) {
                    loading.value = true;
                    const twoFactorRequired = await loginUser(form.email, form.password);
                    if (twoFactorRequired === undefined)
                        return;
                    return router.push(twoFactorRequired ? { name: "auth.two-factor" } : "/");
                }
            }
            catch (err) {
                loading.value = false;
                if (isStatusError(err) && err.statusCode === 422) {
                    const json = await err.json();
                    if (isValidationError(json)) {
                        errors.value = json;
                    }
                }
                else {
                    try {
                        await fetchCurrentUser();
                        return router.push({ name: "users.list" });
                    }
                    catch (err) {
                        //
                    }
                }
            }
        };
        const { loading: loadingInit, fetch } = useFetch(async () => {
            try {
                await fetchCurrentUser();
                await router.push("/");
            }
            catch (err) {
                // This is expected.
            }
        });
        fetch();
        return (_ctx, _cache) => {
            return (!_unref(loadingInit))
                ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
                    _createElementVNode("form", {
                        class: "login-box",
                        onSubmit: _withModifiers(onSubmit, ["prevent"])
                    }, [
                        (_unref(isImpress))
                            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                            : (_unref(isDarkMode))
                                ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                                : (_openBlock(), _createElementBlock("img", _hoisted_5)),
                        _createVNode(Input, {
                            errors: errors.value?.errors?.email,
                            autocomplete: "username",
                            label: "Username",
                            modelValue: _unref(form).email,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).email) = $event))
                        }, {
                            icon: _withCtx(() => [
                                _createVNode(_unref(UserIcon), { class: "icon" })
                            ]),
                            _: 1
                        }, 8, ["errors", "modelValue"]),
                        _createVNode(Input, {
                            errors: errors.value?.errors?.password,
                            autocomplete: "current-password",
                            label: "Password",
                            type: "password",
                            modelValue: _unref(form).password,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).password) = $event))
                        }, {
                            icon: _withCtx(() => [
                                _createVNode(_unref(KeyIcon), { class: "icon" })
                            ]),
                            _: 1
                        }, 8, ["errors", "modelValue"]),
                        _createVNode(Button, { variant: "dark" }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(LoginIcon), { class: "icon" }),
                                _hoisted_6
                            ]),
                            _: 1
                        })
                    ], 40, _hoisted_2)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
